// extracted by mini-css-extract-plugin
export default {"complianceIcon":"ComplianceIcon_complianceIcon__1Ltlt"};